import { Directive, HostListener, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[trimInput]',
  standalone: true,
})
export class TrimInputDirective {
  constructor(@Self() private ngControl: NgControl) {}

  @HostListener('blur')
  onBlur(): void {
    const value = this.ngControl.value;
    if (typeof value === 'string') {
      this.ngControl.control?.setValue(value.trim(), { emitEvent: false });
    }
  }
}
